
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cruzeiros",
      function () {
        return require("private-next-pages/cruzeiros/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cruzeiros"])
      });
    }
  